import { IApiClient } from '../ApiClient';
import { Invoice } from '../ApiModel';
import { AsyncStore } from './AsyncStore';

export default class UnpaidInvoiceStore extends AsyncStore<Invoice[]> {
    constructor(apiClient: IApiClient) {
        super(() => apiClient.getUnpaidInvoices(), []);
    }
}
